import React, { Component } from "react";
import styles from "./Tools.module.css";

class TimestampConverter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "toDate", // "toDate" or "toTimestamp"
      timestampInput: "",
      localTimeResult: "",
      localDateInput: "",
      timestampResult: ""
    };
  }

  handleTimestampChange = (event) => {
    this.setState({ timestampInput: event.target.value });
  };

  handleDateChange = (event) => {
    this.setState({ localDateInput: event.target.value });
  };

  toggleMode = () => {
    this.setState((prevState) => ({
      mode: prevState.mode === "toDate" ? "toTimestamp" : "toDate"
    }));
  };

  convertToLocalTime = () => {
    const rawValue = this.state.timestampInput.trim();

    if (!rawValue) {
      this.setState({ localTimeResult: "" });
      return;
    }

    const numericValue = Number(rawValue);
    if (!Number.isFinite(numericValue)) {
      this.setState({ localTimeResult: "Invalid timestamp" });
      return;
    }

    // Bitcoin timestamps are in seconds
    const millis = rawValue.length > 10 ? numericValue : numericValue * 1000;
    const date = new Date(millis);

    if (Number.isNaN(date.getTime())) {
      this.setState({ localTimeResult: "Invalid timestamp" });
      return;
    }

    this.setState({ localTimeResult: date.toLocaleString(undefined, { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) });
  };

  convertToTimestamp = () => {
    const rawValue = this.state.localDateInput;

    if (!rawValue) {
      this.setState({ timestampResult: "" });
      return;
    }

    const date = new Date(rawValue);

    if (Number.isNaN(date.getTime())) {
      this.setState({ timestampResult: "Invalid date/time" });
      return;
    }

    const seconds = Math.floor(date.getTime() / 1000);
    this.setState({ timestampResult: seconds.toString() });
  };

  render() {
    const {
      mode,
      timestampInput,
      localTimeResult,
      localDateInput,
      timestampResult
    } = this.state;

    const isToDate = mode === "toDate";
    const buttonLabel = isToDate ? "Convert To Local Time" : "Convert To Timestamp";
    const buttonTitle = isToDate
      ? "Convert Unix timestamp to local date/time"
      : "Convert local date/time to Unix timestamp";
    const handleConvert = isToDate ? this.convertToLocalTime : this.convertToTimestamp;

    return (
      <div className={`${styles.tools} times mbox`}>
        <h4
          className="text-center"
          title="Convert between Unix timestamp and local date/time. Bitcoin timestamps are in seconds."
        >
          <i className="bi bi-clock-history" style={{ color: "brown" }}></i>{" "}
          Unix Timestamp Converter
        </h4>
        <hr />
        <table width="100%">
          <tbody>
            {isToDate ? (
              <>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className={`${styles.enterHex}`}>Unix Timestamp:</div>
                    <div width="100%">
                      <input
                        name="timestamp-input"
                        type="text"
                        style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                        value={timestampInput}
                        onChange={this.handleTimestampChange}
                        placeholder="Enter Unix timestamp (seconds or milliseconds)"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-secondary me-2"
                        title="Switch conversion direction"
                        onClick={this.toggleMode}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                        </svg>
                      </button>
                      <button
                        className="btn btn-primary"
                        title={buttonTitle}
                        onClick={handleConvert}>
                        {buttonLabel}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className="label">Local Date/Time:</div>
                    <div width="100%">
                      <input
                        readOnly={true}
                        type="text"
                        style={{
                          width: "100%",
                          padding: "8px",
                          marginTop: "5px",
                          backgroundColor: "lightgray"
                        }}
                        value={localTimeResult}
                      />
                    </div>
                  </td>
                </tr>
              </>
            ) : (
              <>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className={`${styles.enterHex}`}>Local Date/Time:</div>
                    <div width="100%">
                      <input
                        name="date-input"
                        type="datetime-local" step="1"
                        style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                        value={localDateInput}
                        onChange={this.handleDateChange}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-secondary me-2"
                        title="Switch conversion direction"
                        onClick={this.toggleMode}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-up" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                        </svg>
                      </button>
                      <button
                        className="btn btn-primary"
                        title={buttonTitle}
                        onClick={handleConvert}
                      >
                        {buttonLabel}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr style={{ height: 90 }}>
                  <td>
                    <div className="label">Unix Timestamp (seconds):</div>
                    <div width="100%">
                      <input
                        readOnly={true}
                        type="text"
                        style={{
                          width: "100%",
                          padding: "8px",
                          marginTop: "5px",
                          backgroundColor: "lightgray"
                        }}
                        value={timestampResult}
                      />
                    </div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TimestampConverter;
